import React from "react";
import { Row, Col } from "components/bootstrap";
import { DocumentTitle, PageHeader, Spinner, Link } from "components/common";
import PageNavigation from "components/common/PageNavigation";
import AppConfig from "util/AppConfig";
import DocsHelper from "util/DocsHelper";
import useProductName from "brand-customization/useProductName";
import { InputsOverview } from "components/inputs/InputsOveriew";
import useInputTypes from "hooks/useInputTypes";
import Routes from "routing/Routes";
import useInputTypesDescriptions from "hooks/useInputTypesDescriptions";
import InputsNotifications from "components/inputs/InputsNotifications";
const isCloud = AppConfig.isCloud();
export const INPUTS_PAGE_NAV_TITLE = "Inputs";
const InputsPage = () => {
  const productName = useProductName();
  const { data: inputTypes, isLoading: isLoadingInputTypes } = useInputTypes();
  const { data: inputTypeDescriptions, isLoading: isLoadingInputTypesDescriptions } = useInputTypesDescriptions();
  if (isLoadingInputTypes || isLoadingInputTypesDescriptions) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: "Inputs" }, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(PageNavigation, { page: INPUTS_PAGE_NAV_TITLE })), /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title: "Inputs",
      documentationLink: {
        title: "Inputs documentation",
        path: DocsHelper.PAGES.INPUTS
      }
    },
    isCloud ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, " ", productName, " cloud accepts data via inputs. There are many types of inputs to choose from, but only some can run directly in the cloud. You can launch and terminate them on this page."), /* @__PURE__ */ React.createElement("p", null, "If you are missing an input type on this page's list of available inputs, you can start the input on a ", /* @__PURE__ */ React.createElement(Link, { to: Routes.SYSTEM.FORWARDERS }, "Forwarder"), ".")) : /* @__PURE__ */ React.createElement("span", null, productName, " nodes accept data via inputs. Launch or terminate as many inputs as you want here.")
  ), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(InputsNotifications, null), /* @__PURE__ */ React.createElement(InputsOverview, { inputTypeDescriptions, inputTypes }))));
};
export default InputsPage;
